import { reactQueryPost } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useMutation } from "react-query";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";

export const useCommentForm = ({ postId, parentCommentId, onCreate }) => {
  const { error } = useToast();

  const { mutateAsync: createComment } = useMutation({
    mutationFn: commentData =>
      reactQueryPost(internalApi.comments.create({ postId }), {
        comment: { parent_comment_id: parentCommentId, ...commentData },
      }),
    onSuccess: onCreate,
    onError: () => error(t("comments.create.alerts.failure")),
  });

  return { createComment };
};
